import { combineReducers } from 'redux';
import { pathOr, uniq } from 'ramda';
import { createSelector } from 'reselect';
import memoize from 'lodash.memoize';

import { actions } from '../actions/boardgames';

const byId = (state = {}, action) => {
  switch (action.type) {
    case actions.GET_BOARDGAME_STATISTICS_SUCCESS:
      return Object.assign({}, state, pathOr({}, ['payload', 'entities', 'statistics'], action));
    default:
      return state;
  }
};

const byBoardgameId = (state = {}, action) => {
  switch (action.type) {
    case actions.GET_BOARDGAME_STATISTICS_SUCCESS:
      return Object.assign({}, state, {
        [action.payload.id]: uniq(pathOr([], ['payload', 'result'], action)
          .concat(pathOr([], [action.payload.id], state)))
      });
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case actions.GET_BOARDGAME_STATISTICS_REQUEST:
      return true;
    case actions.GET_BOARDGAME_STATISTICS_SUCCESS:
    case actions.GET_BOARDGAME_STATISTICS_FAILED:
      return false;
    default:
      return state;
  }
};


const statistics  = combineReducers({
  byId,
  byBoardgameId,
  loading,
});

export default statistics;

export const statisticsByBoardgameIdSelector = state => state.statistics.byBoardgameId;
export const statisticsByIdSelector = state => state.statistics.byId;
export const getLoadingStatisticsSelector = state => state.statistics.loading;

export const statisticsForBoardgameSelector = createSelector(
  statisticsByIdSelector,
  statisticsByBoardgameIdSelector,
  (byId, byBoardgame) => memoize(
    boardgameId => (boardgameId && (byBoardgame[boardgameId] || []).map(id => byId[id])) || []
  )
);